import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SetupAutomaticPaymentsFlowService } from '../services/setup-automatic-payments-flow.service';
import { environment } from '../../../../../../../environments/environment';
import { SessionService } from '../../../../../../shared/session/session.service';

@Injectable()
export class SetupAutomaticPaymentsConfirmationGuard implements CanActivate {
    constructor(
        private setupPaymentMethodFlow: SetupAutomaticPaymentsFlowService,
        private router: Router,
        private session: SessionService
    ) { }

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.setupPaymentMethodFlow.flowInPlay || this.router.parseUrl(environment.ISB.ENDPOINTS.RELATIVE.paymentPreferences({
            accountNumber: this.session.billingAccountNumber,
            sessionId: this.session.a2aSessionId
        }));
    }
}
